export const complaintSeverityEnum = Object.freeze({
    "SERVICE": 3,
    "DEFECT": 2,
    "EMERGENCY": 1
});